import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {ChannelLogo} from "../../channels/ChannelLogo";
import {FacebookLinkComponent} from "../link_acocunts/FacebookLink";
import {FACEBOOK_CHANNEL} from "../../channels/channels";
import { withTranslation } from 'react-i18next';
import {forgetReconnect} from './reconnectNote';

const noop = () => {};

/**
 * Modal de reconexión de Meta Ads.
 *
 * Meta es el único canal que no reconecta con un redirect OAuth de página completa: usa el SDK JS
 * de Facebook (FacebookLinkComponent), que necesita un botón montado en el DOM para abrir el popup
 * de autorización. Por eso el botón "Reconectar" de una credencial de Meta navega a
 * `?reconnect_pending=FACEBOOK` y AgencyConnectionsConfigurationContent abre este modal al leer el
 * param. Al autorizar, FacebookLinkComponent.responseFacebook persiste el token nuevo y redirige a
 * `?just_connected=FACEBOOK`, restaurando la conexión y re-vinculando las cuentas en el sync.
 */
class FacebookReconnectModalClass extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }

    // Cerrar sin autorizar termina la reconexión de una cuenta que se había anotado (`reconnectNote`):
    // si no, la próxima conexión de Meta se la llevaría como si fuera ésta.
    handleClose() {
        forgetReconnect();
        this.props.onClose();
    }

    render() {
        const {isOpen, reconnectAccId, t} = this.props;
        const onClose = this.handleClose;
        return (
            // El mismo diálogo y el mismo pie que el modal de reconectar una cuenta: a 390, 16 px de margen y los
            // botones apilados con el principal arriba; el cuerpo, con el margen del título (QA-VIS-rp-fe-41/42).
            <Modal isOpen={isOpen} toggle={onClose} backdrop="static" className="reconnect-account-dialog">
                <ModalHeader toggle={onClose}>
                    <ChannelLogo channel={FACEBOOK_CHANNEL}/>&nbsp;{t('facebook_reconnect_modal.title')}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('facebook_reconnect_modal.description')}</p>
                    </div>
                </ModalBody>
                <ModalFooter className="reconnect-account-modal__foot">
                    <button className="btn -negative" onClick={onClose}>
                        {t('facebook_reconnect_modal.cancel')}
                    </button>
                    <FacebookLinkComponent hasConnection={false} reconnectAccId={reconnectAccId}
                                           onConnectionDeleted={noop}/>
                </ModalFooter>
            </Modal>
        );
    }
}

export const FacebookReconnectModal = withTranslation()(FacebookReconnectModalClass);
export default FacebookReconnectModal;
